module.exports = __webpack_public_path__ + "img/4 手机.08836690.png";